<template>
  <div>
    <vs-alert :active.sync="errorOccurred" color="danger" title="Error While Loading Lesson">
      <span>We were unable to load Lesson with Id {{ $route.params.setId }} successfully.</span>
    </vs-alert>
    <div v-if="!errorOccurred">

      <div v-if="setData">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <img class="mr-4 rounded" :src="setData.thumbnail" v-if="setData.thumbnail" width="40" height="40">
                  <h1 class="">{{ setData.name }}</h1>
                </div>
                <div class="flex justify-end items-center">
                  <feather-icon v-if="autoSave.status === 'success'" icon="CheckIcon" svgClasses="h-5 w-5 text-success mr-2"/>
                  <div v-else-if="autoSave.status === 'pending'" class="vs-con-loading__container h-5 w-5 mr-2" id="pendingLoadingCircle"/>
                  <feather-icon v-else icon="XCircleIcon" svgClasses="h-5 w-5 text-danger mr-2"/>
                  <p class="cursor-pointer" @click="saveChanges">{{ autoSave.text }}</p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row mb-base" v-if="setData.practice_enabled && practiceData">
          <div class="vx-col w-full mb-4">
            <h1 class="font-bold ml-2">Build Practice Mode</h1>
          </div>

          <div class="vx-col w-2/3">
            <vx-card>
              <div>
                <h1 class="text-bold ml-1 mb-2" v-if="!isSetLessonsEmpty">Lesson Sets</h1>
                <div class="mb-4 p-6 rounded-lg mt-3" style="background-color: rgba(0,0,0,0.15) ">
                  <div v-if="!isSetLessonsEmpty || dragging === true">
                    <h1 class="my-6 font-bold text-center" v-if="isSetLessonsEmpty && dragging === true">Drop Lesson Here</h1>
                    <draggable class="grid grid-cols-5 gap-5 cursor-move" :list="practiceData.lessons" :group="{name: 'lessons'}"
                               @change="saveChanges(['practice'])"  style="min-height: 15rem">
                      <div class="flex items-center justify-center cursor-pointer"
                           v-for="(lesson, index) in practiceData.lessons">
                        <div class="border border-solid m-3 p-3 rounded cursor-pointer">
                          <p class="text-center mb-3 text-small">{{ lesson.name }}</p>
                          <vs-button color="success" icon-pack="feather" icon="icon-copy" class="w-full mb-2"
                                     type="gradient" size="small" @click="copyText(lesson.id)">Id
                          </vs-button>
                          <vs-button color="danger" icon-pack="feather" icon="icon-trash" class="w-full mb-2"
                                     type="gradient" size="small" @click="removeLessonFromSetConfirm(index)">Remove
                          </vs-button>
                          <vs-button color="warning" icon-pack="feather" icon="icon-edit" class="w-full"
                                     type="gradient" size="small" @click="$router.push(`/a/lessons/${lesson.id}/builder`)">Edit
                          </vs-button>
                        </div>
                      </div>
                    </draggable>
                  </div>
                  <div v-if="isSetLessonsEmpty && dragging === false">
                    <div class="flex items-center justify-center">
                      <lottie-animation
                        path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                        :loop="true" :autoPlay="true" :speed="1" :width="300"/>
                    </div>
                    <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                    <h5 class="text-light text-center mt-2 mb-4">To Add Lessons Drag Them Into This Box</h5>
                  </div>
                </div>
                <vs-button color="primary" icon-pack="feather" icon="icon-plus" class=""
                           type="gradient" @click="lessonCreatePopup = true">Create Lesson
                </vs-button>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-1/3">
            <vx-card class="mb-4">
              <h4>Lesson Bank</h4>
              <vs-input v-model="lessonSearch" @input="fetchLessonsList" class="my-4 mt-5 w-full "
                        placeholder="lesson Search"/>
              <vs-list class="p-0 mt-3" v-if="lessonList.length !== 0">
                <draggable :list="lessonList" :group="{name:'lessons',  pull:'clone', put:false }" :sort="false" :move="checkMove"
                           class="cursor-move" @start="dragging = true" @end="dragging = false">
                  <vs-list-item v-for="(listItem) in lessonList" :key="listItem.id" :title="listItem.name"
                                :subtitle="listItem.id">
                    <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3"/>
                  </vs-list-item>
                </draggable>
              </vs-list>
              <p class="mt-2 p-1" v-else>No Records Found</p>
            </vx-card>
          </div>

        </div>
        <div class="vx-row" v-if="setData.flashcard_enabled && flashcardData">
          <div class="vx-col w-full mb-4">
            <h1 class="font-bold ml-2">Build Flashcard Mode</h1>
          </div>

          <div class="vx-col w-2/3">
            <vx-card>
              <div>
                <h1 class="text-bold ml-1 mb-2" v-if="!isSetLessonsEmpty">Lesson Sets</h1>
                <div class="mb-4 p-6 rounded-lg mt-3" style="background-color: rgba(0,0,0,0.15) ">
                  <div v-if="!isSetLessonsEmpty || dragging === true">
                    <h1 class="my-6 font-bold text-center" v-if="isSetLessonsEmpty && dragging === true">Drop Lesson Here</h1>
                    <draggable class="grid grid-cols-5 gap-5 cursor-move" :list="practiceData.lessons" :group="{name: 'lessons'}"
                               @change="saveChanges(['practice'])"  style="min-height: 15rem">
                      <div class="flex items-center justify-center cursor-pointer"
                           v-for="(lesson, index) in practiceData.lessons">
                        <div class="border border-solid m-3 p-3 rounded cursor-pointer">
                          <p class="text-center mb-3 text-small">{{ lesson.name }}</p>
                          <vs-button color="success" icon-pack="feather" icon="icon-copy" class="w-full mb-2"
                                     type="gradient" size="small" @click="copyText(lesson.id)">Id
                          </vs-button>
                          <vs-button color="danger" icon-pack="feather" icon="icon-trash" class="w-full mb-2"
                                     type="gradient" size="small" @click="removeLessonFromSetConfirm(index)">Remove
                          </vs-button>
                          <vs-button color="warning" icon-pack="feather" icon="icon-edit" class="w-full"
                                     type="gradient" size="small" @click="$router.push(`/a/lessons/${lesson.id}/builder`)">Edit
                          </vs-button>
                        </div>
                      </div>
                    </draggable>
                  </div>
                  <div v-if="isSetLessonsEmpty && dragging === false">
                    <div class="flex items-center justify-center">
                      <lottie-animation
                        path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                        :loop="true" :autoPlay="true" :speed="1" :width="300"/>
                    </div>
                    <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                    <h5 class="text-light text-center mt-2 mb-4">To Add Lessons Drag Them Into This Box</h5>
                  </div>
                </div>
                <vs-button color="primary" icon-pack="feather" icon="icon-plus" class=""
                           type="gradient" @click="lessonCreatePopup = true">Create Lesson
                </vs-button>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-1/3">
            <vx-card class="mb-4">
              <h4>Lesson Bank</h4>
              <vs-input v-model="lessonSearch" @input="fetchLessonsList" class="my-4 mt-5 w-full "
                        placeholder="lesson Search"/>
              <vs-list class="p-0 mt-3" v-if="lessonList.length !== 0">
                <draggable :list="lessonList" :group="{name:'lessons',  pull:'clone', put:false }" :sort="false" :move="checkMove"
                           class="cursor-move" @start="dragging = true" @end="dragging = false">
                  <vs-list-item v-for="(listItem) in lessonList" :key="listItem.id" :title="listItem.name"
                                :subtitle="listItem.id">
                    <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3"/>
                  </vs-list-item>
                </draggable>
              </vs-list>
              <p class="mt-2 p-1" v-else>No Records Found</p>
            </vx-card>
          </div>

        </div>

      </div>

      <div v-else class="simple-spinner">
        <span></span>
      </div>

    </div>

    <vs-popup :active.sync="lessonCreatePopup" title="Create New Lesson" id="CreateLessonPopup">
      <vs-input v-model="lessonCreateName" class="mb-8 w-full" label-placeholder="Name"/>
      <vs-button color="success" type="filled" @click="createLesson">Create Lesson</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '@/components/lottie/LottieAnimation'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      dragging: false,

      setData: null,
      practiceData: null,
      flashcardData: null,


      lessonCreatePopup: false,
      lessonCreateName: '',
      lessonSearch: '',
      lessonList: [],

      removeLessonIndex: null,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ],

      totalSteps: 5,
      currentStep: 0,

      errorOccurred: false,

      autoSave: {
        status: 'success',
        text: 'Ready To Save'
      }

    }
  },
  computed: {
    lessonColorProgress () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'midnight') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    isSetLessonsEmpty () {
      return this.practiceData.lessons.length === 0
    }
  },
  components: {
    RadialProgressBar,
    LottieAnimation,
    draggable
  },
  methods: {
    fetchSetDetails (id) {
      this.$http.get(`sets/${id}?rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.setData = response.data.data
            if (response.data.data.practice_enabled === true) {
              this.fetchPracticeDetails(response.data.data.practice_id)
            }
            if (response.data.data.flashcard_enabled === true) {
              // this.fetchFlashcardDetails(response.data.data.practice_id)
            }
          }
        })
        .catch(() => {
          this.errorOccurred = true
        })
    },
    fetchPracticeDetails (id) {
      this.$http.get(`practice/${id}?rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.practiceData = response.data.data
          }
        })
        .catch(() => {
          this.errorOccurred = true
        })
    },
    fetchFlashcardDetails (id) {
      this.$http.get(`activity/flashcards/${id}?rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.flashcardData = response.data.data
          }
        })
        .catch(() => {
          this.errorOccurred = true
        })
    },
    lottiePlay (ref) {
      this.$refs[ref][0].play()
    },
    lottieStop (ref) {
      this.$refs[ref][0].stop()
    },
    removeLessonFromSetConfirm (index) {
      this.removeLessonIndex = index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Remove Lesson From Set',
        text: 'Please confirm you want remove this lesson from the set.',
        accept: this.removeLessonFromSet,
        acceptText: 'Remove'
      })
    },
    removeLessonFromSet () {
      if (this.removeLessonIndex === null) return
      this.practiceData.lessons.splice(this.removeLessonIndex, 1)
      this.saveChanges(['practice'])
      this.removeLessonIndex === null
    },
    checkMove (evt) {
      let move = true
      this.practiceData.lessons.forEach(set => {
        if (set.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    copyText (x) {
      const thisIns = this
      this.$copyText(x).then(function () {
        thisIns.$vs.notify({
          title: 'Success',
          text: 'ID Copied to Clipboard',
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-clipboard'
        })
      })
    },
    fetchLessonsList () {
      this.$http.get(`practice/lessons?search=${this.lessonSearch}&amount=5`)
        .then(response => {
          if (response.status === 200) {
            this.lessonList = response.data.data
          }
        }).catch(() => {
        })
    },
    createLesson () {
      this.$vs.loading()
      this.$http.post('practice/lessons/create', {name : this.lessonCreateName})
        .then(response => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Created lesson successfully',
              text: `New lesson ${this.lessonCreateName} has been created.`,
              color: 'success',
              position: 'top-right'
            })
            this.practiceData.lessons.push(response.data.data)
            this.saveChanges(['practice'])
            this.lessonCreatePopup = false
            this.lessonCreatePopup = ''
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          let error = 'An unknown error occurred while creating this lesson'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          return this.$vs.notify({
            title: 'Failed to create lesson',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    saveChanges (update) {

      this.autoSave = {
        text: 'Saving...',
        status: 'pending'
      }

      setTimeout(() => {
        this.$vs.loading({
          color: '#FF9F43',
          background: 'transparent',
          container: '#pendingLoadingCircle',
          scale: 0.325,
          type: 'point'
        })
      }, 1)

      if (update.includes('practice')) {
        const pl = []
        this.practiceData.lessons.forEach(lesson => {
          pl.push(lesson.id)
        })
        this.$http.post(`practice/${this.practiceData.id}`, pl)
          .catch(() => {
            this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
            return this.autoSave = {
              text: 'Error While Saving Changes',
              status: 'error'
            }
          })
      }

      setTimeout(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
        const date = new Intl.DateTimeFormat('en-US', {hour: 'numeric', minute: 'numeric', second: 'numeric'})
        this.autoSave = {
          text: `All Changes Saved - ${date.format(new Date())}`,
          status: 'success'
        }
      }, 2500)

    }
  },
  created () {
    this.fetchSetDetails(this.$route.params.setId)
    this.fetchLessonsList()

    setTimeout(() => {
      this.currentStep = 1
    }, 1500)
  }


}
</script>

<style lang="scss">


.theme-midnight {
  #CreateLessonPopup {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }
}

.theme-dark {
  #CreateLessonPopup {
    input.vs-inputx.vs-input--input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }
}


</style>
